import React from "react";
import { createRoot } from "react-dom/client";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";

import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./theme/default/custom.css";
import "./custom.css";
import "react-datepicker/dist/react-datepicker.css";
import "@livekit/components-styles";

import { errorMessages, initValidation } from "./services/utils/validation";
import { ProgressContextProvider } from "./services/utils/progress";
import { ProfileProvider } from "./services/utils/profileContext";
import { customHistory } from "./services/utils/history";
import { AccountSettingsProvider } from "./services/Context/AccSettingContext";
import { ResourceProvider } from "./services/Context/ManageResourceContext";
import { NotifyContextProvider } from "./services/utils/notify";
import { TenantSignalRProvider } from "./services/Context/TenantSignalRContext";
import { DoctorProvider } from "./services/Context/DoctorContext";
import { captureAttribution } from "./services/analytics/attribution";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const root = createRoot(document.getElementById("root"));

// Runs before the first render, so the landing URL is read before cleanQueryParams() strips it and
// before the SSO entry handler navigates away.
captureAttribution();

(async function initApp() {
  try {
    await errorMessages.initialize();
    await initValidation();

    root.render(
      <HistoryRouter history={customHistory} basename={baseUrl}>
        <ProgressContextProvider>
          <NotifyContextProvider>
            <ResourceProvider>
              <DoctorProvider>
                <ProfileProvider>
                  <AccountSettingsProvider>
                    <TenantSignalRProvider hubNames={["notification", "patient", "message"]}>
                      <App />
                    </TenantSignalRProvider>
                  </AccountSettingsProvider>
                </ProfileProvider>
              </DoctorProvider>
            </ResourceProvider>
          </NotifyContextProvider>
        </ProgressContextProvider>
      </HistoryRouter>,
    );
  } catch (err) {
    console.error(err);
  }
})();

serviceWorkerRegistration.unregister();
reportWebVitals();
